import { ConnectionNames } from "../../../Contracts";
import { AsyncSocket, connectionStore, ConfigStore } from "../../../Common";
import { sportsSocketConnectionHandlers } from "../SportsSocketConnectionHandlers";
import { SDQRequestFormatter } from "../SDQRequestFormatter";
import { SDQResponseFormatter } from "../SDQResponseFormatter";
export function createSportsbookConnection(connConfig) {
    const conn = new AsyncSocket({
        url: {
            baseUrl: connConfig.baseUrl,
            queryParams: {
                jwt: ConfigStore.config.connections.jwt,
                locale: connConfig.queryParams.locale
            }
        },
        handlers: sportsSocketConnectionHandlers(SDQRequestFormatter, SDQResponseFormatter)
    });
    connectionStore.set(ConnectionNames.sports, conn);
    return conn;
}
//# sourceMappingURL=CreateSportsbookConnection.js.map